module.exports = "/location-active-adc9e5213ce00ff57a2a15aa01bc48e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/CreateRoute/LocationMarkerGroup/LocationMarker/icons/location-active.svg
// module id = MuZ3
// module chunks = 4